<template>
  <b-modal
    v-model="showModal"
    size="xl"
    @hidden="cancelar"
    @close="cancelar"
    button-size="md"
    hide-footer
    :title="prefix + title"
  >
    <classe-list
      id="finderClasse"
      v-model="form.classe"
      invalidFeedback="Informe uma classe!"
      :prefix="prefix"
      :label="'Classe: *'"
      :subgrupo="currentSubgrupo"
    >
    </classe-list>
  </b-modal>
</template>
<script>
import ClasseList from "../../../modules/cadastros/classe/ClasseList.vue"
export default {
  components: {
    ClasseList,
  },
  name: "ModalPageClasse",
  props: {
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Classe",
    },
    currentSubgrupo: Object,
  },

  data() {
    return {
      subgrupoClasse: {},
      showModal: true,
      form: {
        classe: {},
      },
    }
  },

  beforeMount() {
    this.subgrupoClasse = this.subgrupo
  },

  methods: {
    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
